import { useState, useEffect } from "react";
import apiClient from "../../api/client";

const AVATAR_COLORS = ["#2563eb", "#059669", "#D97706", "#7c3aed", "#dc2626", "#0891b2"];

const timeAgo = (dateStr) => {
  const diff = (Date.now() - new Date(dateStr)) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

const getColor = (name = "") =>
  AVATAR_COLORS[(name.charCodeAt(0) || 0) % AVATAR_COLORS.length];

const getInitials = (name = "") =>
  name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase() || "?";

export default function WorkbookReviews({ workbookId }) {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const isMounted = { current: true };
    apiClient
      .get(`/api/reviews/${workbookId}`)
      .then((data) => {
        if (!isMounted.current) return;
        const sorted = (data.reviews || [])
          .sort((a, b) => b.rating - a.rating)
          .slice(0, 5);
        setReviews(sorted);
      })
      .catch(() => {});
    return () => { isMounted.current = false; };
  }, [workbookId]);

  if (!reviews.length) return null;

  return (
    <div>
      {reviews.map((r) => {
        const name = r.userName || "";
        const ini = r.initials || getInitials(name);
        const color = getColor(name);
        const byline = r.role ? `${name} · ${r.role}` : name;
        return (
          <div
            key={r.id}
            style={{
              background: "white",
              borderRadius: 12,
              padding: "1.1rem 1.25rem",
              marginBottom: "0.75rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: r.reviewText ? "0.6rem" : 0 }}>
              <div
                style={{
                  width: 34, height: 34, borderRadius: "50%",
                  background: color, color: "white",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 12, fontWeight: 700, flexShrink: 0,
                }}
              >
                {ini}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a1a", lineHeight: 1.3 }}>
                  {byline}
                </div>
                <div style={{ display: "flex", gap: 1, marginTop: 2 }}>
                  {[1, 2, 3, 4, 5].map((n) => (
                    <span key={n} style={{ color: "#D97706", fontSize: 12 }}>
                      {n <= r.rating ? "★" : "☆"}
                    </span>
                  ))}
                </div>
              </div>
              {r.createdAt && (
                <span style={{ fontSize: 11, color: "#9a8f7e", flexShrink: 0 }}>
                  {timeAgo(r.createdAt)}
                </span>
              )}
            </div>
            {r.reviewText && (
              <p
                style={{
                  fontFamily: "'Fraunces', serif",
                  fontSize: 14,
                  color: "#3f3f46",
                  fontStyle: "italic",
                  margin: 0,
                  lineHeight: 1.65,
                }}
              >
                "{r.reviewText}"
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
